module.exports = __webpack_public_path__ + "static/media/tzlogo.9f37d0ca.svg";